export enum LlmModel {
  GPT_3 = "gpt-3.5-turbo",
  GPT_4 = "gpt-4"
}
